import { render, staticRenderFns } from "./BusinessContactParent.vue?vue&type=template&id=2707661b&"
import script from "./BusinessContactParent.vue?vue&type=script&lang=js&"
export * from "./BusinessContactParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports